<div class="row filter-type-selection-header">
  <div class="col-6"></div>
  <div class="col-6 text-right">{{ filter.accountTypeSelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-6">
    <p-tree
      [value]="accountTypes"
      (click)="formDirty = true"
      [(selection)]="filter.accountTypeSelection"
      [propagateSelectionUp]="false"
      selectionMode="checkbox"
      (onNodeSelect)="sortSelection(filter.accountTypeSelection)"
      emptyMessage="No records found"
    ></p-tree>
  </div>
  <div class="col-6">
    <p-tree
      class="selected-tree"
      (click)="formDirty = true"
      [value]="filter.accountTypeSelection"
      [(selection)]="filter.accountTypeSelection"
      selectionMode="multiple"
      selectionMode="checkbox"
      emptyMessage=" "
    ></p-tree>
  </div>
</div>
<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="”accountTypes”">
  <input type="hidden" [(ngModel)]="filter.accountTypeSelection" name="acountTypeSelection" #acountTypeSelection="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && acountTypeSelection.invalid"> Please select an option </span>
      </span>
    </div>
  </div>
</fieldset>
